import React, { useMemo } from "react";
import { Stack } from "@mui/material";

import { HubHookFormSelect } from "../HubHookFormSelect";
import { DialogButton } from "../DialogButton";
import { FinancialPeriodDialog } from "../../dialogs/FinancialPeriodDialog";
import { useFinancialPeriodList } from "./useFinancialPeriodList";

export const FinancialPeriodSelect = ({ locationId = 1, ...rest }) => {
  const { periods } = useFinancialPeriodList({ locationId });

  const options = useMemo(
    () =>
      (periods || []).map((p) => ({
        id: p.id,
        label: p.name,
      })),
    [periods],
  );

  return (
    <>
      <Stack direction="row" gap="6px" alignItems="end">
        <Stack flex={1}>
          <HubHookFormSelect
            name="financialPeriodId"
            label="Financial Period"
            options={options}
            disabled={!locationId}
            {...rest}
          />
        </Stack>
        <DialogButton
          name="financial-period"
          variant="tinyButton"
          color="neutral"
          size="xsmall"
          icon="Plus"
          iconProps={{ size: 14 }}
          label="New"
          sx={{ height: "35.81px" }}
        />
      </Stack>
      <FinancialPeriodDialog />
    </>
  );
};

export default FinancialPeriodSelect;
